import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import CustomDocumentType from '../../application/domain/entities/CustomDocumentType';

interface CustomDocumentTypeState {
  customDocumentTypes: CustomDocumentType[];
}

const initialState: CustomDocumentTypeState = {
  customDocumentTypes: [],
};

export const customDocumentTypeSlice = createSlice({
  name: 'customDocumentTypes',
  initialState,
  reducers: {
    setCustomDocumentTypes: (
      state,
      action: PayloadAction<CustomDocumentType[]>
    ) => {
      state.customDocumentTypes = action.payload;
    },
  },
});

export const { setCustomDocumentTypes } = customDocumentTypeSlice.actions;
export default customDocumentTypeSlice.reducer;
